import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { env } from '@amfam/environment';

import { DashboardClaimV2 } from '../+state/claim-v2-dashboard.models';

@Injectable({
  providedIn: 'root'
})
export class ClaimDashboardService {
  private http = inject(HttpClient);

  getDashboardClaims(): Observable<DashboardClaimV2[]> {
    const claimsV2DashboardEndpoint = env.claimV2Api + '/dashboard/claims?limit=6';
    return this.http
      .get<{ data: DashboardClaimV2[] }>(claimsV2DashboardEndpoint)
      .pipe(map(response => response.data));
  }
}
